"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoJSONFeatureCollection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const GeoJSONFeature_1 = require("../GeoJSONFeature");
function GeoJSONFeatureCollection(_a) {
    var { featureCollection } = _a, styleProps = __rest(_a, ["featureCollection"]);
    return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: featureCollection.features.map(feature => (jsx_runtime_1.jsx(GeoJSONFeature_1.GeoJSONFeature, Object.assign({ feature: feature }, styleProps), feature.id))) }, void 0));
}
exports.GeoJSONFeatureCollection = GeoJSONFeatureCollection;
//# sourceMappingURL=index.js.map